"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateStory = exports.getAllStories = exports.getStoryById = exports.submitStoriesForm = void 0;
const axios_1 = __importDefault(require("axios"));
const urls_1 = require("./urls");
const AxiosErrorParse_utils_1 = require("../utils/AxiosErrorParse.utils");
/**
 * Submit new story post
 */
function submitStoriesForm(v) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            // const data = {...v};
            // if (v.imageData) {
            // 	// EC2 server can't handle large images (413 Error)
            // 	// Need to proxy file upload through a compatible server (currently HCL)
            // 	const mime: string = v.imageData.substring(v.imageData.indexOf(":") + 1, v.imageData.indexOf(";"));
            // 	let extension = "";
            // 	switch (mime) {
            // 		case 'image/jpeg':
            // 			extension = "jpg";
            // 			break;
            // 		case 'image/png':
            // 			extension = "png";
            // 			break;
            // 	}
            // 	data.imageFilename = `${Date.now()}_${v.lastName}_${v.firstName}.${extension}`;
            // 	const hclRequest = {
            // 		imageData: data.imageData,
            // 		imageFilename: data.imageFilename,
            // 	}
            // 	const hclResponse = await axios.post("https://homecareerleads.com/pixel-moments/aws-s3-upload.php",
            // 		hclRequest,
            // 		{
            // 			headers: {
            // 				"accept": "application/json",
            // 				"content-type": "application/x-www-form-urlencoded",
            // 			}
            // 		}
            // 	);
            // 	if (hclResponse.data !== "SUCCESS") {
            // 		return {
            // 			success: false,
            // 			error: "Image could not be uploaded",
            // 		}
            // 	}
            //
            // 	// Delete image data from request before sending to express server
            // 	delete data.imageData;
            // }
            const res = yield axios_1.default.post(urls_1.fullURLS.STORIES, v);
            return {
                success: res.status === 200,
                data: res.data,
            };
        }
        catch (err) {
            return AxiosErrorParse_utils_1.AxiosErrorParse(err);
        }
    });
}
exports.submitStoriesForm = submitStoriesForm;
/**
 * Get story data from ID
 * @param id - MongoDB ID of story
 */
function getStoryById(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield axios_1.default.get(urls_1.fullURLS.STORIES, {
                params: {
                    id,
                }
            });
            return { success: res.status === 200, data: res.data };
        }
        catch (err) {
            return AxiosErrorParse_utils_1.AxiosErrorParse(err);
        }
    });
}
exports.getStoryById = getStoryById;
/**
 * Get all stories
 * @param authToken - Authorization token of administrator
 */
function getAllStories(authToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield axios_1.default.get(urls_1.fullURLS.STORIES_ADMIN, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            return { success: res.status === 200, data: res.data };
        }
        catch (err) {
            return AxiosErrorParse_utils_1.AxiosErrorParse(err);
        }
    });
}
exports.getAllStories = getAllStories;
/**
 * Update story data
 * @param data - New story data
 * @param authToken - Authorization token of administrator
 */
function updateStory(data, authToken) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield axios_1.default.patch(urls_1.fullURLS.STORIES_ADMIN, data, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            return { success: res.status === 200, data: res.data };
        }
        catch (err) {
            return AxiosErrorParse_utils_1.AxiosErrorParse(err);
        }
    });
}
exports.updateStory = updateStory;
//# sourceMappingURL=stories.js.map